import { useContext } from "react"
import useUploadDocumentsAuth from "./useUploadDocumentsAuth"
import useUploadDocumentsHandler from "./useUploadDocumentsHandler"
import useUploadDocumentsModal from "./useUploadDocumentsModal"
import useUploadDocumentQueries from "./useUploadDocumentsQueries"
import useUploadDocumentResources from "./useUploadDocumentsResources"
import NotyfContext from "../../../../../../contexts/NotyfContext"

export default function useUploadDocumentsLogic(id){

    const resources = useUploadDocumentResources({ id })
    const queries = useUploadDocumentQueries({ ...resources })
    const auth = useUploadDocumentsAuth({ ...resources })
    const handlers = useUploadDocumentsHandler({ ...resources, ...queries })
    const modals = useUploadDocumentsModal({ ...handlers, ...queries })
    const notyf = useContext(NotyfContext)

    return {
        ...auth,
        ...queries,
        ...modals,
        ...handlers,
        ...resources,
        notyf
    }
}